import { useState } from "react";
import { ActivityReportUIProvider } from "./ActivityReportUIContext";
import { ExplanationModal } from "./explanation-modal/ExplanationModal";
import { ActivityReportCard } from "./ActivityReportCard";

export function ActivityReportPage() {
  const [activityId, setActivityId] = useState();
  const [showExplanationModal, setShowExplanationModal] = useState();
  const closeExplanationModal = () => setShowExplanationModal(false);
  
  const activityReportUIEvents = {
    openExplanationModal: (id) => {
      setActivityId(id);
      setShowExplanationModal(true);
    }
  };

  return (
    <ActivityReportUIProvider activityReportUIEvents={activityReportUIEvents}>
      <ExplanationModal
        activityId={activityId}
        showExplanationModal={showExplanationModal}
        closeExplanationModal={closeExplanationModal}
      />
      <ActivityReportCard />
    </ActivityReportUIProvider>
 );
}